namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;

    export interface IDiagnosis {
		id: number;
		code: string;
		name: string;
		description: string;
		type: string;
    }

    export class Diagnosis implements IDiagnosis {
		id: number;
		code: string;
		name: string;
		description: string;
		type: string;

        constructor(obj?: IDiagnosis | psgm.DiagnosisModel | any) {
			this.id = null;
			this.code = '';
			this.name = '';
			this.description = '';
			this.type = null;

			if (obj) {
				this.id = obj.id || obj.diagnosisId || null;
				this.code = obj.code || obj.diagnosisCode || '';
				this.name = obj.name || obj.diagnosisName || '';
				this.description = obj.description || obj.diagnosisDescription || '';
				this.type = obj.type || obj.diagnosisType || null;
            }
        }
    }
}
